export { default, SETUP_PASSWORD_PATH } from "./SetupPasswordPage";
